import { render, staticRenderFns } from "./BalanceItem.vue?vue&type=template&id=c49d4da0"
import script from "./BalanceItem.vue?vue&type=script&lang=js"
export * from "./BalanceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports